/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ResyncRequest
 */
export interface ResyncRequest {
  /**
   *
   * @type {Array<string>}
   * @memberof ResyncRequest
   */
  trackingIds: Array<string>;
}

/**
 * Check if a given object implements the ResyncRequest interface.
 */
export function instanceOfResyncRequest(value: object): value is ResyncRequest {
  if (!("trackingIds" in value) || value["trackingIds"] === undefined)
    return false;
  return true;
}

export function ResyncRequestFromJSON(json: any): ResyncRequest {
  return ResyncRequestFromJSONTyped(json, false);
}

export function ResyncRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResyncRequest {
  if (json == null) {
    return json;
  }
  return {
    trackingIds: json["trackingIds"],
  };
}

export function ResyncRequestToJSON(json: any): ResyncRequest {
  return ResyncRequestToJSONTyped(json, false);
}

export function ResyncRequestToJSONTyped(
  value?: ResyncRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    trackingIds: value["trackingIds"],
  };
}
